import * as React from 'react';
import { SVGProps } from 'react';

const IconLithologyStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 5h1v2H3V5ZM9 5H8v2h1V5ZM5 9V8h2v1H5ZM5 3v1h2V3H5Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2Zm8 1H2v8h8V2Z"
    />
  </svg>
);
export default IconLithologyStrokedSizeXs;
